export default __webpack_public_path__ + "static/media/stausIconQueue.4eedf9a7.svg";